module.exports = __webpack_public_path__ + "img/check.7373844e.svg";